import {Component, inject, OnInit, signal} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ToasterComponent} from './shared/ui-components/toaster/toaster.component';
import {SidebarComponent} from './shared/ui-components/sidebar/sidebar.component';
import {AuthService} from './core/services/auth.service';
import {NavbarComponent} from './shared/ui-components/navbar/navbar.component';
import {SignSectionWrapperComponent} from './shared/ui-components/sign-section-wrapper/sign-section-wrapper.component';
import {UserSectionWrapperComponent} from './shared/ui-components/user-section-wrapper/user-section-wrapper.component';
import {LayoutService} from './core/util/services/layout.service';
import {NgClass} from '@angular/common';
import {PermissionService} from './core/util/services/permission.service';
import {UserService} from './core/services/user.service';
import {RouteInterceptorService} from './core/interceptors/navigation.interceptor';
import {SupplierService} from './core/services/supplier.service';
import {IEretailUser} from './core/models/user/eretailUser';
import { HasPermissionDirective } from './core/directives/HasPermissionDirective';
import { HasNotPermissionDirective } from './core/directives/HasNotPermission.directive';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ToasterComponent,
    SidebarComponent,
    NavbarComponent,
    SignSectionWrapperComponent,
    UserSectionWrapperComponent,
    NgClass,
    HasNotPermissionDirective
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [RouteInterceptorService],
})
export class AppComponent implements OnInit {
  title = 'e-retail-web';
  variables: any;

  protected _auth = inject(AuthService);
  protected _user = inject(UserService);
  protected _layout = inject(LayoutService);
  protected _permission = inject(PermissionService);
  protected _supplierService = inject(SupplierService);

  isUserAuth = signal<boolean>(true);
  isMenuCollapsed = signal<boolean>(false);

  // Inicializa currentUser com null
  currentUser = signal<IEretailUser | null>(null);

  constructor() {
    this._layout.loadColors();
    this.isUserAuth.set(this._auth.isUserAuthenticated());

    if (this._auth.isUserAuthenticated()) {
      const user = this._user.currentUser;
      if (user) {
        this.currentUser.set(user);
        this._user.setLocalFunctions();
        this._user.setLocalProfiles();
      }
    }
  }

  ngOnInit() {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      document.body.classList.add('dark-theme');
    }
  }

  handleMenuOpen(event: boolean) {
    this.isMenuCollapsed.set(event);
  }
}
